import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const ASCII_DIVIDER = `  ================================================================`;

export default function CTASection() {
  return (
    <section className="bg-navy-950 py-14 sm:py-20 px-4 sm:px-6">
      <div className="max-w-3xl mx-auto text-center">
        <pre className="font-mono text-[10px] text-bone-white/15 leading-tight whitespace-pre select-none mb-6 sm:mb-8 hidden sm:block">
          {ASCII_DIVIDER}
        </pre>
        <div className="h-px bg-navy-800/50 mb-6 sm:hidden" />

        <h2 className="font-serif text-bone-white text-2xl sm:text-3xl md:text-4xl mb-4">
          Start accepting USDC on Solana.
        </h2>
        <p className="font-sans text-bone-white/60 text-sm sm:text-base mb-8 sm:mb-10 leading-relaxed">
          Apply for access. Get approved. Install the plugin.<br />
          Customers pay in USDC, orders complete automatically.
        </p>

        <Link
          to="/apply"
          className="inline-flex items-center gap-2 font-mono text-sm font-medium bg-bone-white text-navy-900 px-8 py-3 rounded-subtle hover:bg-navy-100 transition-colors uppercase tracking-wider group"
        >
          Apply Now
          <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
        </Link>

        <div className="mt-6 sm:mt-8 flex flex-wrap justify-center gap-4 sm:gap-6">
          {['Non-custodial', 'On-chain verified', 'HMAC-signed webhooks', 'Auto order completion'].map((item) => (
            <span key={item} className="font-mono text-[10px] sm:text-xs text-bone-white/40 uppercase tracking-wider">
              {item}
            </span>
          ))}
        </div>

        <pre className="font-mono text-[10px] text-bone-white/15 leading-tight whitespace-pre select-none mt-6 sm:mt-8 hidden sm:block">
          {ASCII_DIVIDER}
        </pre>
        <div className="h-px bg-navy-800/50 mt-6 sm:hidden" />
      </div>
    </section>
  );
}
